import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Swal from "sweetalert2";
import { menuDynamicRoute, menuStaticRoute } from "../utils/constant";
import {
  getRouteIndex,
  handleNavigate,
  handleRestriction,
} from "../utils/common";
import moment from "moment";

const menuChildActiveRoutes = {
  "/admin/my-chatbots": ["/admin/bot-settings"],
  "/my-chatbots": ["/bot-settings"],
  "/agency/my-chatbots": ["/agency/bot-settings"],
  "/admin/role-management": ["/admin/role-management/view"],
  "/role-management": ["/role-management/view"],
  "/agency/role-management": ["/agency/role-management/view"],
  "/admin/cms": ["/admin/cms/create", "/admin/cms/edit"],
  "/agency/cms": ["/agency/cms/create", "/agency/cms/edit"],
};

const normalizePath = (path = "") => path.split("?")[0].split("#")[0];
const isMatchingPath = (currentPath, targetPath) =>
  currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);

export default function CoolbizAuthNavbar({ navToggle, setNavToggle }) {
  const { logout, user, accessType, companyInfo } = useAuth();
  const location = useLocation();
  const currentLocation = location.pathname;
  const navigate = useNavigate();
  const FCMTOKEN = localStorage.getItem("FcmToken");
  let inc = 0;
  let lastInd = 0;

  const handleCloseNav = (type = "", permission = false) => {
    setNavToggle(false); // Close the side menu
    if (
      user?.subscriptionStatus === 0 &&
      (user.userType == 2 || user.userType == 4) &&
      type != "logout" &&
      type != "profile" &&
      !permission
    ) {
      Swal.fire(
        "To access the features, please choose a subscription plan. Once subscribed, the menu on the left will be unlocked for you.",
      );
    } else if (
      user.userType == 5 &&
      (user?.isAccountOnboarding != 1 ||
        user?.isAccountOnboarding == undefined) &&
      type != "logout" &&
      !permission
    ) {
      Swal.fire(
        "Please setup your stripe account first. Once done, you'll be able to share your referral.",
      );
    } else if (user.userType == 3 && type != "logout" && !permission) {
      if (
        (user?.subscriptionStatus == 2 && user?.isGracePeriod == 2) ||
        user?.subscriptionStatus === 3
      ) {
        Swal.fire(`Activate Your Plan! To enjoy uninterrupted services1.`);
      } else {
        if (user?.subscriptionStatus === 2) {
          Swal.fire(
            `Your Last payment has been failed. Make your payment to avoid service interruption.`,
          );
        }
        if (user?.subscriptionStatus === 0) {
          Swal.fire(
            `To access the features, please choose a subscription plan. Once subscribed, the menu on the left will be unlocked for you.`,
          );
        } else if (
          user?.isAccountOnboarding != 1 &&
          type != "my-subscription" &&
          type != "my-payment-account-details"
        ) {
          Swal.fire("Please setup your payment accept account.");
        } else if (
          !user?.logoLink &&
          type != "branding-management" &&
          type != "my-subscription" &&
          type != "my-payment-account-details"
        ) {
          Swal.fire("Please setup your branding management first.");
        }
      }
    } else if (accessType === 4 && type != "logout" && user.userType !== 6) {
      if (
        user?.userSubscription &&
        user?.subscriptionStatus !== 1 &&
        user?.parentIsGracePeriod <= 2
      ) {
        Swal.fire("Activate Your Plan! To enjoy uninterrupted services2.");
      } else if (user?.parentIsGracePeriod === 3) {
        Swal.fire({
          title: `Due to the non-renewal of your parent agency’s subscription, your service has been discontinued from ${moment(
            new Date(user?.subscriptionEndDate),
          ).format(
            "DD MMM YYYY",
          )}. However, you can continue using your bot and retain access to your user base by migrating your account directly to BottBuddy.`,
          showCancelButton: true,
          confirmButtonText: "See Migration Policy",
        }).then((result) => {
          if (result.isConfirmed) {
            // If 'Confirm' is clicked, navigate to the migration consent page
            navigate(`/migration-consent?userUuid=${user?.userUuid}`);
          } else {
            // If 'Cancel' is clicked, handle the cancel action here
            // You can just leave it empty or perform some other action if needed
            console.log("Migration canceled");
          }
        });
        // }
      }
    } else if (accessType === 2 && type != "logout" && user.userType !== 6) {
      if (user?.userSubscription && user?.subscriptionStatus !== 1) {
        Swal.fire(`Activate Your Plan! To enjoy uninterrupted services3.`);
      }
    }
  };
  const isActive = (path) =>
    path?.some((pathname) =>
      isMatchingPath(currentLocation, normalizePath(pathname)),
    );
  const getActivePathnames = (path) =>
    path?.flatMap((pathname) => {
      const normalizedPathname = normalizePath(pathname);
      return [
        normalizedPathname,
        ...(menuChildActiveRoutes[normalizedPathname] ?? []),
      ];
    });
  const getMenuPath = (menuName) =>
    menuDynamicRoute[menuName]?.route?.[getRouteIndex(accessType)];
  const getMenuActivePathnames = (menuName) =>
    getActivePathnames([getMenuPath(menuName)]).filter(Boolean);
  const isMenuActive = (menuName) => isActive(getMenuActivePathnames(menuName));
  const getParentActivePathnames = (parentName) =>
    user?.menus
      ?.filter(
        (menu) => menuDynamicRoute[menu?.menuName]?.parent === parentName,
      )
      .flatMap((menu) => getMenuActivePathnames(menu?.menuName)) ?? [];

  const handleLogoutClick = async (event) => {
    event.preventDefault();

    const result = await Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to log out of your account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    handleCloseNav("logout");
    logout({ firebaseToken: FCMTOKEN }, accessType);
  };

  // console.log(
  //   "user type",
  //   accessType,
  //   menuDynamicRoute[user.menus[0].menuName].route[0]
  // );

  return (
    <div className={navToggle ? "dashboard-left open-nav" : "dashboard-left"}>
      <button className="dashboard-nav-close" onClick={() => handleCloseNav()}>
        <img src="/images/cross-icon-b.png" alt="cross-icon-b" />
      </button>
      <figure className="logo">
        <a
          onClick={(e) => {
            e.preventDefault();
            handleNavigate(
              navigate,
              handleRestriction(user, accessType, "dashboard"),
              currentLocation,
            );
            handleCloseNav("dashboard");
          }}
          href="#"
        >
          <img
            src={
              accessType == 4 || user?.parentType == 3
                ? !!companyInfo?.logo
                  ? companyInfo?.logo
                  : "/images/bottbuddy.png"
                : "/images/bottbuddy.png"
            }
            alt="logo"
          />
        </a>
      </figure>
      <header>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleNavigate(
              navigate,
              menuStaticRoute[4]?.profile.route[getRouteIndex(accessType)],
              currentLocation,
            );
            handleCloseNav("profile");
          }}
        >
          <figure>
            <img
              src={!!user?.fileLink ? user?.fileLink : "/images/images-100.png"}
              alt="logo"
            />
          </figure>
        </a>
        <aside>
          <h6>{user?.fullName ?? ""}</h6>
          <small>
            <p>{user?.email ?? ""}</p>
          </small>
        </aside>
      </header>

      <menu id="dynamic-id">
        <ul>
          {user?.menus?.map((menu, index) => {
            let counter = 0;
            return !!menuDynamicRoute[menu?.menuName]?.parent ? (
              index >= lastInd + inc && (
                <li
                  key={index}
                  className={
                    isActive(
                      getParentActivePathnames(
                        menuDynamicRoute[menu?.menuName]?.parent,
                      ),
                    )
                      ? "active"
                      : ""
                  }
                >
                  <a
                    onClick={(e) => {
                      handleNavigate(
                        navigate,
                        handleRestriction(user, accessType, menu?.menuName),
                        currentLocation,
                      );
                      handleCloseNav(menu?.menuName);
                      e.preventDefault();
                    }}
                    href="#"
                  >
                    <img
                      src={`${
                        menuDynamicRoute[menu?.menuName]?.parentIcon
                      }.svg`}
                      alt=""
                    />
                    <img
                      src={`${
                        menuDynamicRoute[menu?.menuName]?.parentIcon
                      }-hov.svg`}
                      alt=""
                    />
                    {menuDynamicRoute[menu?.menuName]?.parent}
                  </a>
                  <ul className="submenu">
                    {user.menus.slice(index)?.map((innerMenu, ind) => {
                      if (
                        menuDynamicRoute[menu?.menuName]?.parent ===
                        menuDynamicRoute[innerMenu?.menuName]?.parent
                      ) {
                        lastInd = index;
                        counter++; // Increment the counter on each valid render
                        inc = counter;
                        return (
                          <li
                            key={ind}
                            className={
                              isMenuActive(innerMenu?.menuName) ? "select" : ""
                            }
                          >
                            <a
                              href="#"
                              onClick={(e) => {
                                handleNavigate(
                                  navigate,
                                  handleRestriction(
                                    user,
                                    accessType,
                                    innerMenu?.menuName,
                                  ),
                                  currentLocation,
                                );
                                handleCloseNav(innerMenu?.menuName);
                                e.preventDefault();
                              }}
                            >
                              {menuDynamicRoute[innerMenu?.menuName]?.label}
                            </a>
                          </li>
                        );
                      } else {
                        return null; // Skip rendering if condition doesn't match
                      }
                    })}
                  </ul>
                </li>
              )
            ) : (
              <li
                key={index}
                className={
                  isActive(
                    getActivePathnames(
                      accessType === 1
                        ? [menuDynamicRoute[menu?.menuName]?.route[0]]
                        : accessType === 5
                          ? [menuDynamicRoute[menu?.menuName]?.route[3]]
                          : accessType === 3
                            ? [menuDynamicRoute[menu?.menuName]?.route[2]]
                            : [menuDynamicRoute[menu?.menuName]?.route[1]],
                    ),
                  )
                    ? "active"
                    : ""
                }
              >
                <a
                  href="#"
                  onClick={(e) => {
                    handleNavigate(
                      navigate,
                      handleRestriction(user, accessType, menu?.menuName),
                      currentLocation,
                    );
                    handleCloseNav(menu?.menuName);
                    e.preventDefault();
                  }}
                >
                  <img
                    src={`${menuDynamicRoute[menu?.menuName]?.icon}.svg`}
                    alt=""
                  />
                  <img
                    src={`${menuDynamicRoute[menu?.menuName]?.icon}-hov.svg`}
                    alt=""
                  />
                  {menuDynamicRoute[menu?.menuName]?.label}
                </a>
              </li>
            );
          })}

          {user.userType == 1 && (
            <>
              <li
                className={
                  location.pathname == "/admin/pricing-query" ? "active" : ""
                }
              >
                <a
                  href="#"
                  onClick={(e) => {
                    handleNavigate(
                      navigate,
                      "/admin/pricing-query",
                      currentLocation,
                    );
                    handleCloseNav("pricing-query");
                    e.preventDefault();
                  }}
                >
                  <img src="/images/icons/menu-pricing-query.svg" alt="" />
                  <img src="/images/icons/menu-pricing-query-hov.svg" alt="" />
                  Pricing Query
                </a>
              </li>

              <li
                className={
                  location.pathname == "/admin/sample-prompt-and-qna"
                    ? "active"
                    : ""
                }
              >
                <a
                  href="#"
                  onClick={(e) => {
                    handleNavigate(
                      navigate,
                      "/admin/sample-prompt-and-qna",
                      currentLocation,
                    );
                    handleCloseNav("sample-prompt-and-qna");
                    e.preventDefault();
                  }}
                >
                  <img src="/images/icons/menu-sample-prompt.svg" alt="" />
                  <img src="/images/icons/menu-sample-prompt-hov.svg" alt="" />
                  Sample Promt And Q&A
                </a>
              </li>

              <li
                className={
                  location.pathname == "/admin/exchange-rate-setting"
                    ? "active"
                    : ""
                }
              >
                <a
                  href="#"
                  onClick={(e) => {
                    handleNavigate(
                      navigate,
                      "/admin/exchange-rate-setting",
                      currentLocation,
                    );
                    handleCloseNav("exchange-rate-setting");
                    e.preventDefault();
                  }}
                >
                  <img
                    src="/images/icons/menu-customer-subscription-details.svg"
                    alt=""
                  />
                  <img
                    src="/images/icons/menu-customer-subscription-details-hov.svg"
                    alt=""
                  />
                  Currency Exchange Rate Settings
                </a>
              </li>
            </>
          )}
        </ul>
      </menu>

      <footer>
        <ul>
          {menuStaticRoute?.map(
            (menu, index) =>
              (([2, 3, 4, 5].includes(accessType) &&
                (Object.keys(menu)[0] == "feedback" ||
                  Object.keys(menu)[0] == "help")) ||
                Object.keys(menu)[0] == "settings" ||
                (Object.keys(menu)[0] == "chatbot-model-settings" &&
                  accessType === 1)) && (
                <li
                  key={index}
                  className={
                    isActive(
                      accessType === 1
                        ? [menu[Object.keys(menu)[0]].route[0]]
                        : accessType === 5
                          ? [menu[Object.keys(menu)[0]].route[3]]
                          : accessType === 3
                            ? [menu[Object.keys(menu)[0]].route[2]]
                            : [menu[Object.keys(menu)[0]].route[1]],
                    )
                      ? "active"
                      : ""
                  }
                >
                  <a
                    // to={}
                    href="#"
                    onClick={(e) => {
                      handleNavigate(
                        navigate,
                        menu[Object.keys(menu)[0]]?.route[
                          getRouteIndex(accessType)
                        ],
                        currentLocation,
                      );
                      handleCloseNav(Object.keys(menu)[0], true);
                      e.preventDefault();
                    }}
                  >
                    <img
                      src={`${menu[Object.keys(menu)[0]].icon}.svg`}
                      alt=""
                    />
                    <img
                      src={`${menu[Object.keys(menu)[0]].icon}-hov.svg`}
                      alt=""
                    />
                    {menu[Object.keys(menu)[0]].label}
                  </a>
                </li>
              ),
          )}
          <li>
            <Link to="#" onClick={handleLogoutClick}>
              <img src="/images/icons/menu-logout.svg" alt="" />
              <img src="/images/icons/menu-logout-hov.svg" alt="" />
              Log Out
            </Link>
          </li>
        </ul>
      </footer>
    </div>
  );
}
